import {token} from "@atlaskit/tokens";
import {TableLoadingComponent} from "~/components/ottopilotDataViewer/tableLoadingComponent";
import {twJoin} from "tailwind-merge";

export function KanbanCardSkeleton(props: {pinnedRail?: boolean; className?: string}) {
    const {pinnedRail = false, className} = props;

    if (pinnedRail === true) {
        return (
            <div
                aria-hidden={true}
                className={twJoin(
                    "shrink-0 mx-auto overflow-hidden",
                    className,
                )}
                style={{
                    borderRadius: token("radius.large"),
                    height: "4.5rem",
                    width: "1.375rem",
                }}
            >
                <TableLoadingComponent className="h-full w-full min-h-0" />
            </div>
        );
    }

    return (
        <div
            aria-hidden={true}
            className={twJoin("w-full min-h-30 overflow-hidden rounded-[0.75rem]", className)}
        >
            <TableLoadingComponent className="h-full min-h-30 w-full" />
        </div>
    );
}
